import * as Yup from "yup";

export const ServiceRoleSchema = Yup.object().shape({
    rolname: Yup.string().required("Пожалуйста, укажите системное название"),
    shown_name: Yup.string().required("Пожалуйста, укажите отображаемое название"),
    description: Yup.string(),
});
